import React, { useState } from "react";
import "./FAQ.css";
import { trackEvent } from "./UtilsFunction";

// const FAQ_ITEMS = [
//   {
//     question: "What can I use BrowseNext Captions & Hashtags for?",
//     answer:
//       "BrowseNext helps you find caption ideas and hashtags for your social media posts. You can also format your caption with different text styles and copy your hashtags when you're ready to post.",
//   },
//   {
//     question: "How can I get caption ideas for Instagram?",
//     answer:
//       "BrowseNext provides suggested caption ideas that you can browse and select for your social media posts. You can also write your own caption and customize its style.",
//   },
//   {
//     question: "Where can I find captions for Instagram posts?",
//     answer:
//       "You can use BrowseNext to explore caption ideas for different types of social media posts, then select and customize a caption you like.",
//   },
//   {
//     question: "Can I create a caption for my own post?",
//     answer:
//       "Yes. You can type your own caption and use the available formatting options to style your text.",
//   },
//   {
//     question: "Can I use the suggested captions?",
//     answer:
//       "Yes. Click a suggested caption to select it and customize it for your post.",
//   },
//   {
//     question: "Can I make my caption bold?",
//     answer:
//       "Yes. BrowseNext lets you apply different text styles, including bold and other decorative font styles.",
//   },
//   {
//     question: "Can I copy hashtags for my Instagram post?",
//     answer:
//       "Yes. Use Copy Hashtags to quickly copy the suggested hashtags and use them in your social media post.",
//   },
//   {
//     question: "Can I use BrowseNext captions for Instagram posts?",
//     answer:
//       "Yes. BrowseNext caption and hashtag ideas can be used for Instagram and other social media posts.",
//   },
//   {
//     question: "Are BrowseNext captions and hashtags free?",
//     answer:
//       "Yes. BrowseNext provides caption and hashtag ideas that you can use for your social media content.",
//   },
 
// ];

const FAQ_ITEMS = [
  {
    question: "How do I find a caption for my post?",
    answer:
      "Browse suggested caption ideas on BrowseNext, choose one you like, and customize it before posting.",
  },
  {
    question: "Can I find love caption ideas?",
    answer:
      "Yes. BrowseNext includes caption ideas for different moods and types of posts, including love and romantic posts.",
  },
  // {
  //   question: "Can I find captions in English and Hinglish?",
  //   answer:
  //     "Yes. BrowseNext includes caption ideas in styles that feel natural for different users, including English and Hinglish captions.",
  // },
//  {
//   question: "Can I make my caption bold?",
//   answer:
//     "Yes. Simply type your caption in the box on the left, and you can immediately see your caption in bold on the right. You can then copy the bold caption and use it in your post.",
// },
  {
    question: "Can I change the style of my caption?",
    answer:
      "Yes. You can apply different text styles to your caption, including bold, italic, script, and other decorative styles.",
  },
   {
  question: "Does BrowseNext give caption ideas?",
    answer:
      "Yes. BrowseNext provides caption ideas for different types of social media posts. You can browse the suggestions, choose a caption you like, and customize or copy it for your post.",
  },
  
  // {
  //   question: "How do I copy a caption?",
  //   answer:
  //     "Choose or write a caption, then use the copy option to copy it and paste it into your social media post.",
  // },
  {
    question: "Can I copy hashtags for my post?",
    answer:
      "Yes. BrowseNext lets you quickly copy suggested hashtags to use with your social media posts.",
  },
  {
    question: "Is BrowseNext free to use?",
    answer:
      "Yes. You can use BrowseNext to explore caption ideas, style your text, and copy captions and hashtags for your posts.",
  },
  {
  question: "Can I use BrowseNext as a bold font generator?",
  answer:
    "Yes. Type your text into the caption box and choose the bold style to turn your text into bold font text that you can copy and use in your social media posts.",
},

{
  question: "Can I use BrowseNext as an italic text generator?",
  answer:
    "Yes. Type your text into the caption box and choose the italic style to instantly create italic text that you can copy and use in your posts.",
},
{
  question: "Can I make bold font text for Facebook?",
  answer:
    "Yes. Type your text into BrowseNext, choose the bold style, and copy the bold text to use in your Facebook posts, captions, or comments.",
},
 
];

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  // const handleToggle = (index) => {
  //   setOpenIndex((currentIndex) =>
  //     currentIndex === index ? null : index
  //   );
  // };

  const handleToggle = (index) => {
  setOpenIndex((currentIndex) => {
    const isCurrentlyOpen = currentIndex === index;

    // Track only when the FAQ is being opened
    if (!isCurrentlyOpen) {
      trackEvent("faq_open", {
        // question: FAQ_ITEMS[index].question,
        categoryImage: FAQ_ITEMS[index].question,
        // faq_index: index,
        imagePosition: index,
           clickedImageFromComponent: window.location.pathname,
      });
    }

    return isCurrentlyOpen ? null : index;
  });
};

  return (
    <section className="container app_container faq mt-top" data-nosnippet>
      <div className="faq__header">
        <h2 className="faq__title">
          Frequently Asked Questions
        </h2>

        <p className="faq__description">
          Find answers to common questions about BrowseNext
          captions, hashtags, and post creation.
        </p>
      </div>

      <div className="faq__list">
        {FAQ_ITEMS.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={item.question}
              className={`faq__item ${
                isOpen ? "faq__item--open" : ""
              }`}
            >
              <button
                type="button"
                className="faq__question"
                onClick={() => handleToggle(index)}
                aria-expanded={isOpen}
                aria-controls={`faq-answer-${index}`}
              >
                <span>{item.question}</span>

                <span
                  className={`faq__icon ${
                    isOpen ? "faq__icon--open" : ""
                  }`}
                  aria-hidden="true"
                >
                  +
                </span>
              </button>

              <div
                id={`faq-answer-${index}`}
                className="faq__answer-wrapper"
                hidden={!isOpen}
              >
                <div className="faq__answer">
                  {item.answer}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FAQ;

// font generator
// bold font generator
// bold text generator
// bold text generator copy and paste
// italic text generator
// fancy text generator